export enum IconType {
  Rectangle = 0,
  Circle = 1,
  Polygon = 2
}
